import { Model } from '@/model/Model'
import { IStateMachine } from '@stateMachine/IStateMachine'

export class BaseState {
    protected readonly _model: Model
    protected readonly _stateMachine: IStateMachine
    protected readonly _id: string

    public constructor(stateMachine: IStateMachine, model: Model, id: string) {
        this._model = model
        this._stateMachine = stateMachine
        this._id = id
    }

    public begin() {
        // empty
    }

    public end = (data?: any) => {
        // empty
    }

    public cleanUp() {
        // empty
    }

    public get id(): string {
        return this._id
    }
}
